export const environment = {
  production: true,
  apiBaseUrl: 'https://api.cipa.smosc.com.br',
  smocipaClientBaseUrl: 'https://cipa.smosc.com.br',
  syncfusionLicenseKey: '',
};